import { useLanguage } from '../../../contexts/LanguageContext';
import { formatDate, formatTime, formatTimeRange } from './utils/appointmentUtils';

export default function CreateAppointmentEventValue({ event }) {
  const { value } = event;
  const { t, currentLanguage } = useLanguage();

  // 取得 meta_data 中的 ID
  const metaData = value?.meta_data || {};

  // 地點 ID 轉換為地點代碼
  const getLocationCode = (locationId) => {
    const locationMapping = {
      2000068: "L-HV",  // Happy Valley
      200070: "L-PP"    // Peak Practice
    };
    return locationMapping[locationId] || locationId;
  };

  return (
    <div className="space-y-1">
      <div className="font-medium text-green-600">
        ✅ {t('createAppointment.title')}
      </div>
      <div className="text-sm text-gray-600">
        <span className="font-medium"> 👨‍⚕️ {t('createAppointment.doctor')}:</span> {value?.doctor_name || t('createAppointment.notAvailable')}
      </div>
      <div className="text-sm text-gray-600">
        <span className="font-medium"> 📅 {t('createAppointment.date')}:</span> {formatDate(value?.appointment_date)}
      </div>
      <div className="text-sm text-gray-600">
        <span className="font-medium"> 🕐 {t('createAppointment.time')}:</span> {formatTimeRange(value?.appointment_start_time, value?.appointment_end_time)}
      </div>
      {metaData?.location_id && (
        <div className="text-sm text-gray-600">
          <span className="font-medium">📍 {t('createAppointment.location')}:</span> {getLocationCode(metaData.location_id)}
        </div>
      )}
      {value?.remarks && value.remarks !== '' && value.remarks !== '-' && (
        <div className="text-sm text-gray-600">
          <span className="font-medium">{t('createAppointment.remarks')}:</span> {value.remarks}
        </div>
      )}

      {/* 系統資訊 - 所有相關的 IDs */}
      {(metaData?.confirmed_event_id || metaData?.confirmed_info_event_id || metaData?.confirmed_offer_event_id) && (
        <div className="space-y-1">
          <div className="text-xs text-gray-500">{t('createAppointment.systemInfo')}:</div>
          {metaData?.confirmed_event_id && (
            <div className="text-xs text-blue-600 font-medium">
              🆔 {t('createAppointment.confirmedEventId')}: {metaData.confirmed_event_id}
            </div>
          )}
          {metaData?.confirmed_info_event_id && (
            <div className="text-xs text-gray-500">📋 {t('createAppointment.appointmentInfoId')}: {metaData.confirmed_info_event_id}</div>
          )}
          {metaData?.confirmed_offer_event_id && (
            <div className="text-xs text-gray-500">🗓️ {t('createAppointment.appointmentOfferId')}: {metaData.confirmed_offer_event_id}</div>
          )}
        </div>
      )}
    </div>
  );
}
